import request from '@/api/request'
import store from '@/store'

export function listTestVin(brand, region) {
  return request({
    url: '/testDataAdmin/listTestVin',
    method: 'get',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    }
  })
}

export function testDataAdminIsTestVin(vin) {
  return request({
    url: `/testDataAdmin/isTestVin/${vin}`,
    method: 'get',
  })
}

export function testDataAdminLoadODPRegistration(vin) {
  return request({
    url: `/testDataAdmin/getODPRegistration/${vin}`,
    method: 'get',
  })
}

export function testDataAdminGetSops(vin) {
  return request({
    url: `/testDataAdmin/getSops/${vin}`,
    method: 'get',
  })
}

export function testDataAdminLoadVinFunctions(vin, data) {
  return request({
    url: `/testDataAdmin/getFunctions/${vin}`,
    method: 'post',
    data,
  })
}

export function testDataAdminGetFecAndMetadata(vin) {
  return request({
    url: `/testDataAdmin/getFecAndMetadata/${vin}`,
    method: 'get',
  })
}

export function testDataAdminAddTestVin(vin) {
  return request({
    url: `/testDataAdmin/addTestVin/${vin}`,
    method: 'post',
  })
}

export function testDataAdminOdpRegister(vin) {
  return request({
    url: `/testDataAdmin/odpRegister/${vin}`,
    method: 'post',
  })
}

export function testDataAdminOdpUnregister(vin) {
  return request({
    url: `/testDataAdmin/odpUnregister/${vin}`,
    method: 'post',
  })
}

export function testDataAdminUpdateVinSop(vin, data) {
  return request({
    url: `/testDataAdmin/updateVinSop/${vin}`,
    method: 'post',
    data,
  })
}

export function testDataAdminUpdateVinFunction(vin, data) {
  return request({
    url: `/testDataAdmin/updateVinFunction/${vin}`,
    method: 'post',
    data,
  })
}

export function testDataAdminUpdateFecAndMetadata(vin, data) {
  return request({
    url: `/testDataAdmin/updateFecAndMetadata/${vin}`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}

export function testDataAdminDeleteTestData(vin) {
  return request({
    url: `/testDataAdmin/delete/${vin}`,
    method: 'delete',
  })
}
